import { GetBalanceByUserIdQuery } from "@/graphql";
import { useCallback, useMemo, useState } from "react";
import ExcelJS from "exceljs";
import moment from "moment";

export function useBalanceHistoryExcel({
  data,
}: {
  data: GetBalanceByUserIdQuery["getBalanceByUserId"]["balanceHistory"];
}) {
  const [loading, setLoading] = useState(false);
  const columns = useMemo(() => {
    const columns = [
      { header: "Худалдан авалтын дүн", key: "title" },
      { header: "Огноо", key: "createdAt" },
      { header: "Хөрөнгө оруулсан дүн", key: "principleAmount" },
      { header: "Шимтгэл", key: "fee" },
    ];
    const check = new Set<string>();

    data?.map((item) => {
      item.stocks?.map((stock) => {
        if (!check.has(stock.stock.symbol)) {
          check.add(stock.stock.symbol);
          columns.push({
            header: stock.stock.symbol,
            key: stock.stock.symbol,
          });
          columns.push({
            header: "Тоо ширхэг",
            key: stock.stock.symbol + "Тоо ширхэг",
          });
          columns.push({
            header: "Худалдаж авсан дүн",
            key: stock.stock.symbol + "Худалдаж авсан дүн",
          });
          columns.push({
            header: "Ширхэгийн үнэ",
            key: stock.stock.symbol + "Ширхэгийн үнэ",
          });
          columns.push({
            header: "Шимтгэл",
            key: stock.stock.symbol + "Шимтгэл",
          });
        }
      });

      item.bonds?.map((bond) => {
        if (!check.has(bond.bond.symbol)) {
          check.add(bond.bond.symbol);
          columns.push({ header: bond.bond.symbol, key: bond.bond.symbol });
          columns.push({
            header: "Худалдаж авсан дүн",
            key: bond.bond.symbol + "Худалдаж авсан дүн",
          });

          columns.push({
            header: "Шимтгэл",
            key: bond.bond.symbol + "Шимтгэл",
          });
        }
      });

      item.savings?.map((saving) => {
        if (!check.has(saving.saving.bankName)) {
          check.add(saving.saving.bankName);
          columns.push({
            header: "Банкны нэр",
            key: saving.saving.bankName,
          });
          columns.push({
            header: "Данс",
            key: saving.saving.bankName + "Данс",
          });
          columns.push({
            header: "Худалдаж авсан дүн",
            key: saving.saving.bankName + "Худалдаж авсан дүн",
          });
          columns.push({
            header: "Шимтгэл",
            key: saving.saving.bankName + "Шимтгэл",
          });
        }
      });
    });

    columns.push({ header: "Худалдан авалтаас үлдсэн дүн", key: "holdAmountLast" });

    return columns;
  }, [data]);

  const downloadBalanceExcel = useCallback(async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("history");

    worksheet.columns = [
      ...columns.map((column) => ({
        ...column,
      })),
    ];

    data?.map((item) => {
      const row: Record<string, any> = {
        title: item.title,
        createdAt: moment(item.createdAt).format("YYYY/MM/DD HH:mm:ss"),
        principleAmount: item.principleAmount,
        fee: item.fee,
      };

      item.stocks.map((stock) => {
        row[stock.stock.symbol] = stock.stock.name;
        row[stock.stock.symbol + "Тоо ширхэг"] = stock.totalAmount.toFixed(6);
        row[stock.stock.symbol + "Худалдаж авсан дүн"] =
          new Intl.NumberFormat().format(stock.totalPrice);
        row[stock.stock.symbol + "Ширхэгийн үнэ"] =
          new Intl.NumberFormat().format(stock.unitPrice);
        row[stock.stock.symbol + "Шимтгэл"] = new Intl.NumberFormat().format(
          stock.fee
        );
      });

      item.bonds?.map((bond) => {
        row[bond.bond.symbol] = bond.bond.name;
        row[bond.bond.symbol + "Худалдаж авсан дүн"] =
          new Intl.NumberFormat().format(bond.principleAmount);
        row[bond.bond.symbol + "Шимтгэл"] = new Intl.NumberFormat().format(
          bond.fee
        );
      });

      item.savings?.map((savings) => {
        row[savings.saving.bankName] = savings.saving.bankName;
        row[savings.saving.bankName + "Данс"] = savings.saving.accountNo;
        row[savings.saving.bankName + "Худалдаж авсан дүн"] =
          new Intl.NumberFormat().format(savings.principleAmount);
        row[savings.saving.bankName + "Шимтгэл"] =
          new Intl.NumberFormat().format(savings.fee);
      });
      //columns.push({ header: "Худалдан авалтаас үлдсэн дүн", key: "holdAmountLast" });
      row["holdAmountLast"] = new Intl.NumberFormat().format(
        item.stocks.reduce((sum, stock) => {
          return sum + stock.holdAmount;
        }, 0)
      );
      worksheet.addRow(row);
    });

    const blob = new Blob([await workbook.xlsx.writeBuffer()], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    setLoading(false);
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
  }, [data, columns]);

  return { loading, downloadBalanceExcel };
}
